<template>
    <div>
        <div class='footer-column-title'>
            About us
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('working-together/why-choose-majestic-commercial')"><a class="footer-link">Why Majestic Commercial?</a></div>
            <div @click="onClickLink('working-together/data-driven-menus')"><a class="footer-link">Data-Driven Menus</a></div>
            <div @click="onClickLink('working-together/drinks-training')"><a class="footer-link">Drinks Training</a></div>
            <div @click="onClickLink('working-together/marketing-and-events')"><a class="footer-link">Marketing & Events</a></div>
            <div @click="onClickLink('about-us/sustainability')"><a class="footer-link">Sustainability</a></div>
            <div @click="onClickLink('about-us/people-and-culture')"><a class="footer-link">Current Vacancies</a></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page, exteneral = false) {
            if(!exteneral){
                this.$router.push(`/${page}`);
            }
            else{
                window.location.href = page;
            }
        }
    }
}
</script>
